
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { CompanyReportAdminState } from './types-store';
import { reducer as companyReportAdminFormReducer, INITIAL_STATE as companyReportAdminFormState } from './form/reducers';
import { reducer as companyReportsAdminListReducer, INITIAL_STATE as companyReportsAdminListState } from './list/reducers';

export const INITIAL_STATE: CompanyReportAdminState = {
  form: companyReportAdminFormState,
  list: companyReportsAdminListState
};

export const reducer: Reducer<CompanyReportAdminState> = withOptionsReducer(
  STATE.companyReportAdministration,
  mergeReducers({
    form: companyReportAdminFormReducer,
    list: companyReportsAdminListReducer
  })
);
